<template>
  <div v-if="Object.values(habilitacao).length > 0"
       class="content--sinoreg Resumo">
    <header-blue class="headerBlueResumo">
      <h4 class="resumo-show_title pl-2">
        <b-row>
          <div class="pr-0 d-flex align-items-center registro_title">
            <icon-svg icon="engagement"
                      class="icon--md icons--white typeIcon ml-3 mr-2 mt-2" />
            E-Habilitacao
          </div>
          <div class="registro_dados">
            <b-row>
              <b-col cols="8"
                     class="m-0 p-0">
                <b-row>
                  <HeaderBoxCasamento v-if="habilitacao.registro_id"
                                      info-title="Cônjuge 1"
                                      :info-name="habilitacao.registro.pessoas[0].nome_antigo"
                                      :info-cpf="habilitacao.registro.pessoas[0].cpf | cpf" />
                </b-row>
                <b-row>
                  <HeaderBoxCasamento v-if="habilitacao.registro_id"
                                      info-title="Cônjuge 2"
                                      :info-name="habilitacao.registro.pessoas[1].nome_antigo"
                                      :info-cpf="habilitacao.registro.pessoas[1].cpf | cpf" />
                </b-row> 
              </b-col>
              <b-col cols="4"
                     class="d-flex justify-content-end navegacao">
                <b-row>
                  <NavegacaoRegistros :prop-registro-id="habilitacao.registro_id"
                                      :prop-tipo-registro="habilitacao.registro.tipo_registro" />
                </b-row>
                <div />
              </b-col>
            </b-row>

            <b-row> 
              <b-col cols="8"
                     class="m-0 p-0">
                <b-row>
                  <HeaderBoxResume v-if="habilitacao.registro_id"
                                   :info="habilitacao.registro.data_registro | date"
                                   text="Data de registro" />
                  <HeaderBoxResume v-if="habilitacao.registro_id"
                                   class="matricula_id"
                                   :info="habilitacao.registro.matricula | maskMatricula"
                                   text="Matrícula" />
                </b-row>
              </b-col>
              <b-col cols="4">
                <button class="row btn btn-sm btn-outline-primary btn-block btn-acessar-reg-cas pt-2 pb-2"
                        type="button"
                        :disabled="(!habilitacao.casamento || !habilitacao.casamento.casamento_id)"
                        @click="acessarRegistroCasamento()">
                  Acessar registro de casamento
                </button>
              </b-col>
            </b-row>
          </div>
        </b-row>
      </h4>
    </header-blue>
    <b-tabs v-model="tabIndex"
            content-class=""
            class="Resumo-border"
            align="left"
            active-nav-item-class="Resumo--tab-active">
      <b-tab :active="tabIndex == 0">
        <template v-slot:title>
          <icon-svg icon="engagement"
                    class="icon--sm" />
          Resumo
        </template>

        <resumo-habilitacao-casamento-detalhes
          :prop-habilitacao="habilitacao"
          @onGerarAutuacao="gerarAutuacao()"
          @reload="init()" />
      </b-tab>

      <b-tab @click="showMessage()">
        <template v-slot:title>
          <icon-svg icon="folderOpen"
                    class="icon--sm" />
          E-habilitação
        </template>

        <eHabilitacao v-if="show && tabIndex == 1 && verifyEhabilitacao()"
                      :prop-habilitacao="habilitacao"
                      @onNewDocs="docs => udpateDocs(docs)"
                      @onEHabilitacaoAtualizada="updateHabilitacao" />
        <div v-else />
      </b-tab>

      <!-- comentando pra esconder imagens -->
      <!--<b-tab>
        <template v-slot:title>
          <icon-svg icon="image"
                    class="icon&#45;&#45;sm" />
          Imagens
        </template>

        <resumo-imagens
          v-if="registro_id"
          tipo-registro="D"
          :allow-add="false"
          :prop-imagens="habilitacao.registro.documentos"
          :registro-id="registro_id" />
      </b-tab>-->

      <b-tab @click="tabIndex = 2">
        <template v-slot:title>
          <icon-svg icon="note"
                    class="icon--sm" />
          Averbações/Anotações
        </template>

        <resumo-averbacoes
          v-if="registro_id && tabIndex == 2"
          :registro-id="registro_id"
          :tipo-registro="habilitacao.registro.tipo_registro" />
      </b-tab>

      <b-tab :active="newOs || tabIndex == 3 || !!propIdOs"
             @click="tabIndex=3">
        <template v-slot:title>
          <icon-svg icon="dolar"
                    class="icon--sm" />
          Ordens de Serviços
        </template>

        <resumo-ordens-servicos
          v-if="registro_id && tabIndex == 3"
          :prop-solicitante="solicitante"
          :prop-registro-id="registro_id"
          :prop-tipo="'habilitacao'"
          :prop-registro="habilitacao.registro"
          :prop-data="habilitacao"
          :prop-novo="compNewOs"
          :prop-os-autuacao="os_gerar_autuacao"
          :prop-os="propIdOs"
          @onUpdateOrdemServico="updateOrdemServico"
          @onNewOs="value => newOs = value"
          @imprimir="imprimir"
          @gerarAutuacao="gerarAutuacaoOS()" />
      </b-tab>

      <b-tab id="tab_impressao">
        <template v-slot:title>
          <icon-svg icon="print"
                    class="icon--sm" />
          Impressão
        </template>

        <impressao v-if="tabIndex == 4"
                   :data="habilitacao"
                   :ordem-servico="ordem_servico"
                   :prop-imprimir-os="os"
                   :prop-minuta="impressaoMinuta"
                   tipo="habilitacao" />
        <div v-else />
      </b-tab>

      <b-tab :active="tabIndex === 5">
        <template v-slot:title>
          <icon-svg icon="qrcode"
                    class="icon--sm" />
          Selos
        </template>

        <ResumoSelos v-if="tabIndex === 5"
                     :prop-registro-id="habilitacao.registro_id || registro_id"
                     :prop-cpf-registrado="habilitacao.registro.pessoas[0].cpf || habilitacao.registro.pessoas[1].cpf"
                     :prop-nome-registrado="habilitacao.registro.pessoas[0].nome_antigo || habilitacao.registro.pessoas[1].nome_antigo"
                     :prop-open-window-editar-vinculacao="propOpenWindowEditarVinculacao" />
      </b-tab>
    </b-tabs>

    <b-modal v-if="modal.show"
             id="modal-sm"
             class="ResumoHabilitacaoCasamento--modalOS"
             hide-header
             hide-footer
             centered
             :visible="true"
             size="lg"
             @hide="resetModalOs()">
      <h5>Escolha a qual OS deseja vincular a autuação:</h5>

      <div class="ml-3">
        <b-form-radio v-for="(os, index) in ordem_servico"
                      :id="`os_modal_${ _uid }_${ index }`"
                      :key="`os_modal_${ _uid }_${ index }`"
                      v-model="modal.ordemServico"
                      class="mt-2"
                      :value="os.ordem_servico_id">
          OS {{ os.numero }}
        </b-form-radio>
      </div>

      <div class="text-right">
        <button class="btn btn-default"
                @click="resetModalOs()">
          Voltar
        </button>
        <button class="btn btn-primary"
                :disabled="!modal.ordemServico"
                @click="gerarAutuacao(true)">
          Continuar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* componentes */
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"
  import HeaderBoxResume from "@/components/SofiaRei/Busca/HeaderBoxResume"
  import HeaderBoxCasamento from "@/components/SofiaRei/Busca/HeaderBoxCasamento"
  import ResumoHabilitacaoCasamentoDetalhes from "@/components/SofiaRei/HabilitacaoCasamento/Resumo/ResumoHabilitacaoCasamentoDetalhes"
  import ResumoAverbacoes from "@/components/SofiaRei/Resumo/ResumoAverbacoes"
  import ResumoOrdensServicos from "@/components/SofiaRei/Resumo/ResumoOrdensServicos"
  import Impressao from "@/components/SofiaRei/Resumo/Impressao/Impressao"
  import eHabilitacao from "@/components/SofiaRei/HabilitacaoCasamento/Resumo/eHabilitacao"
  import NavegacaoRegistros from '@/components/SofiaRei/NavegacaoRegistros'
  import ResumoSelos from '@/components/SofiaRei/Resumo/Selo/ResumoSelos'

  /* services */
  import HabilitacaoService from "@/services/Registros/Habilitacao"

  /* libraries */
  import moment from 'moment'
  import { mapGetters } from "vuex"

  /* vuex */
  import Bry from '@/helpers/Bry'

  /* helpers */
  import ProclamasSignature from '@/signature/ProclamasSignature'


  export default {
    name: "ResumoHabilitacaoCasamento",
    components: {
      HeaderBlue,
      HeaderBoxResume,
      HeaderBoxCasamento,
      ResumoHabilitacaoCasamentoDetalhes,
      ResumoAverbacoes,
      ResumoOrdensServicos,
      Impressao,
      eHabilitacao,
      NavegacaoRegistros,
      ResumoSelos
    },
    props: {
      propAutuacao: {
        type: Boolean,
        default: () => false
      },
      propOs: {
        type: Boolean,
        default: () => false
      },
      propHabilitacao: {type: Object, default: () => ({})},
      propImpressao: { type: Boolean, default: false},
      propImpressaoMemorialAditivo: { type: Boolean, default: false},
      propMostrarSelo: { type: Boolean, default: () => false },
      propOpenWindowEditarVinculacao: { type: Object, default: () => null },
      propIdOs: { type: Number, default: null}
    },
    data () {
      return {
        tabIndex: 0,
        habilitacao_id: this.$route.params.id,
        registro_id: null,
        habilitacao: {},
        solicitante: {},
        ordem_servico: [],
        show: false,
        modal: {
          show: false,
          ordemServico: null
        },
        os: {},
        newOs: false,
        os_gerar_autuacao: false,
        impressaoMinuta: null, // minuta default
        gerenciarExibicaoRecibo: false
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        modalImpressaoEstaFechado: 'impressaoReciboOS/getModalImpressaoEstaFechado',
        recusarImpressaoReciboDeServico: 'impressaoReciboOS/getRecusarImpressaoReciboDeServico'
      }),
      compNewOs () {
        return this.newOs && this.ordem_servico.length == 0
      }
    },
    watch: {
      propAutuacao () {
        if (this.propAutuacao) {
          this.gerarAutuacao()
        }
      },
      propHabilitacao () {
        if (Object.values(this.propHabilitacao).length) {
          this.changeRegistro(this.propHabilitacao)
          return
        }
      },
      propMostrarSelo () {
        if (this.propMostrarSelo) {
          this.tabIndex = 5
        }
      },
      modalImpressaoEstaFechado (novoValor) {
        this.gerenciarExibicaoRecibo = novoValor
      },
      gerenciarExibicaoRecibo (novoValor) {
        if (novoValor) this.tabIndex = 4
      },
      recusarImpressaoReciboDeServico () {
        this.tabIndex = 4
      }
    },
    async beforeMount () {
      if (this.$route.query && this.$route.query.mostrarSelos) {
        const params = {
          propMostrarSelo: true
        }

        if (this.$route.query.seloVinculador && this.$route.query.dataVinculacao) {
          params.propOpenWindowEditarVinculacao = {
            numSeloVinculador: this.$route.query.seloVinculador,
            dataVinculacao: moment(this.$route.query.dataVinculacao, 'DD-MM-YYYY-HH-mm-ss').format('YYYY-MM-DD HH:mm:ss')
          }
        }

        /**
         * Precisamos fazer um push na mesma rota, para passar as props, e para limpar a query do route, pois é imutável.
         * Se não fizermos isso, ao atualizar a página, sempre vai direcionar lá para tab de selos novamente, e queremos que o usuário navegue livremente.
         */
        this.$router.push({ name: 'resumo_habilitacao_casamento', params: { id: this.$route.params.id, ...params } })
      }

      await this.init()

      if (this.propAutuacao) {
        await this.gerarAutuacao()
      }

      if (this.propImpressao) {
        setTimeout(() => {
          const impressao = document.querySelector('#tab_impressao___BV_tab_button__')

          if (impressao) {
            impressao.click()
          }
        }, 1000)
      }
      if (this.propImpressaoMemorialAditivo && !this.propAutuacao) {
        loader({ text: "Aguarde...", active: true })

        // Fazemos essa validação, pois acima tem uma chamada que já gera autuação
        let swalQuestion = { ...objSwal.question }
        swalQuestion.title = "Gostaria de gerar autuação?"
        swalQuestion.cancelButtonText = "Não"
        swalQuestion.confirmButtonText = "Sim"

        const status = await Swal.fire(swalQuestion)

        // Caso confirme só geramos a autuação, caso contrário redirecionamos para o memorial aditivo
        if (status.value) {
          if (this.ordem_servico.length == 1) {
            // quando for somente uma os, o id vinculara automaticamente
            this.habilitacao.gerar_autuacao_os = this.ordem_servico[0].ordem_servico_id
          } else {
            loader({ active: false })

            displayMessage('error', 'Atenção!', 'Para gerar a autuação é necessário 1 Ordem de Serviço cadastrada')

            return
          }

          return this.executarGerarAutuacao()
        }

        this.impressaoMinuta = 'memorial_aditivo'

        setTimeout(() => {
          const impressao = document.querySelector('#tab_impressao___BV_tab_button__')

          if (impressao) {
            impressao.click()
          }
        }, 1000)
      } else {
        this.impressaoMinuta = null
      }
    },
    methods: {
      async init () {
        try {
          this.show = false
          loader({ text: "Carregando...", active: true })

          this.habilitacao = await HabilitacaoService.getHabilitacaoById(this.habilitacao_id, this.$store.state.auth.cartorio_id)
          this.registro_id = this.habilitacao.registro_id
          this.updateOrdemServico(this.habilitacao.registro.ordemServico)
        } catch (e) {
          if (!this.registro_id || (e.response && e.response.status === 404)) {
            this.$router.push('/pagina-nao-encontrada')
          }
        } finally {
          loader({ active: false })
          this.show = true
        }
      },
      updateOrdemServico (data) {
        if (data) this.ordem_servico = [...data]
        else this.ordem_servico = []
      },
      udpateDocs (docs) {
        this.habilitacao.documentos = docs
      },
      updateHabilitacao () {
        this.init()
      },
      imprimir (os) {
        this.os = os
      },
      verifyEhabilitacao () {
        if (this.ordem_servico.length > 0) {
          return true
        } else {
          return false
        }
      },
      showMessage () {
        if (this.verifyEhabilitacao()) return

        return this.displayError(null, 'Crie uma OS para a e-Habilitação ser gerada.').then(() => {
          this.tabIndex = 3
        })

      },
      displayError (title, text, html) {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = html

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        return Swal.fire(objSwal.error).then((res) => {
          objSwal.error.title = ''
          objSwal.error.text = ''
          objSwal.error.html = ''

          return res
        })
      },
      changeRegistro (habilitacao) {
        this.show = false
        this.habilitacao = habilitacao
        this.registro_id = habilitacao.registro_id
        this.updateOrdemServico(habilitacao.registro.ordemServico)
        this.show = true
        this.newOs = false
        this.tabIndex = 0
      },

      // TODO: pensar numa forma de deixar global contagem de dias, meses, anos
      countDays (dataInicial, dataFinal = null) {
        if (!dataFinal) {
          dataFinal = moment(new Date()).format("YYYY-MM-DD")
        }

        return moment().diff(dataInicial, 'days')
      },
      async gerarAutuacao (jump = false) {
        // o jump só vai vir true quando selecionar a os no modal e irá cair no else
        if (!jump) {
          let swalQuestion = { ...objSwal.question }
          swalQuestion.title = "Gostaria de gerar autuação?"
          swalQuestion.cancelButtonText = "Não"
          swalQuestion.confirmButtonText = "Sim"

          const status = await Swal.fire(swalQuestion)

          if (!status.value) return

          if (this.ordem_servico.length > 1) {
            // quando for mais que duas os, abrirá um modal para o mesmo ser escolhido
            this.resetModalOs()
            this.modal.show = true
            return
          } else if (this.ordem_servico.length == 1) {
            // quando for somente uma os, o id vinculara automaticamente
            this.habilitacao.gerar_autuacao_os = this.ordem_servico[0].ordem_servico_id
          }

          if (this.ordem_servico.length == 0) {
            // mudamos para ordem de serviços
            this.newOs = true
            this.tabIndex = 3
            this.os_gerar_autuacao = true

            displayMessage('error', 'Atenção!', 'Para gerar a autuação é necessário 1 Ordem de Serviço cadastrada')
            return
          }
        } else {
          // pegamos a ordem de serviço
          this.habilitacao.gerar_autuacao_os = this.modal.ordemServico
        }

        return this.executarGerarAutuacao()
      },
      async executarGerarAutuacao () {
        try  {
          this.modal.show = false
          loader({ active: true, text: 'Gerando documento...' })
          // geramos o pdf
          const { success, autuacao } = await HabilitacaoService.gerarAutuacao(this.habilitacao)

          // caso tenha dado certo
          if (success) {
            loader({ active: false, text: 'Chamando assinador...' })

            const certificado = await this.$store.dispatch('bry/getCertificate')

            // chamamos o assinador
            loader({ active: true, text: 'Chamando assinador...' })
            if (certificado) {
              const { certId } = certificado
              const initData = await HabilitacaoService.iniciarAssinaturaAutuacao(certificado.certificateData, autuacao)

              // Trata o objeto da assinatura
              const assinaturasObj = initData.assinaturasInicializadas.map(({ nonce, messageDigest }) => {
                return Bry.prepareContentForSignature(messageDigest, nonce)
              })

              // finalizando assinatura
              const { assinaturas } = await Bry.sign(certId, assinaturasObj)

              const end = await HabilitacaoService.finalizarAssinaturaAutuacao(initData.nonce, assinaturas, this.habilitacao)

              // enviando e-proclamas
              await this.publicacaoUnica(certificado)

              this.habilitacao.gerar_autuacao = true
              const { params: { id } } = this.$route

              // atualizamos a habilitacao
              const habilitacao = await HabilitacaoService.updateHabilitacao(this.habilitacao, id)
              this.habilitacao = habilitacao
            }
          }
        } catch (e) {
          console.error('Erro ao gerar autuaçao', e)

          // tratando erro do assinador
          if (!!e.description && !!e.code) {
            displayMessage('error', 'Erro no assinador!', e.description)
          }
        } finally {
          loader({ active: false })
        }
      },
      async publicacaoUnica (certificado) {
        try {
          const { publicacao } = this.habilitacao
          // caso não tenha nenhuma informação
          if (publicacao != 'E_PROCLAMAS') return

          loader({ text: "Enviando publicação...", active: true })
          // Passamos o certificado selecionado para a classe de assinatura
          const assinadorPublicacao = new ProclamasSignature()
          assinadorPublicacao.onSelectCertificado(certificado)

          // Iniciamos a assinatura passando o id do registro
          const res = await assinadorPublicacao.publicacao(this.habilitacao.registro_id)

          // Se não tiver erros retornamos uma mensagem de sucesso e recarregamos o registro
          if (!res.errors || !res.errors.length) {
            displayMessage('success', 'Publicação enviada com sucesso')
          }
        } catch (error) {
          // Usamos esse metodo para verificar o tipo de erro e retornar de forma adequada
          // this.filterErros(error)
        } finally {
          loader({ text: "", active: false })
        }
      },
      resetModalOs () {
        this.modal.show = false
        this.modal.ordemServico = null
      },
      gerarAutuacaoOS () {
        this.os_gerar_autuacao = false
        this.newOs = false
        this.tabIndex = 0

        this.gerarAutuacao()
      },
      acessarRegistroCasamento () {
        if (!this.habilitacao.casamento || !this.habilitacao.casamento.casamento_id) return

        const url = `${window.location.origin}/casamento/resumo/${this.habilitacao.casamento.casamento_id}`

        window.open(url)
      }
    }
  }
</script>

<style  lang="scss">
  @import "./src/scss/_components/resumos";
  .headerBlueResumo{
    height: 215px;
  }
  .Resumo{
    & .nav-link.disabled {
      background-color: #dddddd !important;
    }
  }

  .registro {
    &_title {
      width: 21% !important;
    }

    &_dados {
      width: 78%;
    }
  }

  .ResumoHabilitacaoCasamento--modalOS {
    & .modal-lg {
      width: 500px;
    }
  }

  .btn-acessar-reg-cas {
    border: solid 1px #086aae;
    background-color: #ffffff;
    color: #074f7f;
  }

  .btn-acessar-reg-cas:hover {
    color: #074f7f;
    background-color: #ffffff;
  }

  .btn-acessar-reg-cas:disabled {
    color: #074f7f;
    background-color: #ffffff;
    opacity: 0.65;
  }
  .navegacao {
    padding-left: 8rem;
  }
</style>
